import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

export default function AuthCallbackPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const { processOAuthSession } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        // Prevent double processing in StrictMode
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const processSession = async () => {
            // Extract session_id from URL fragment
            const hash = location.hash;
            const sessionIdMatch = hash.match(/session_id=([^&]+)/);
            
            if (!sessionIdMatch) {
                toast.error('Invalid authentication callback');
                navigate('/login');
                return;
            }

            const sessionId = sessionIdMatch[1];

            try {
                await processOAuthSession(sessionId);
                toast.success('Welcome!');
                navigate('/dashboard', { replace: true });
            } catch (error) {
                console.error('OAuth error:', error);
                toast.error('Authentication failed');
                navigate('/login', { replace: true });
            }
        };

        processSession();
    }, [location, navigate, processOAuthSession]);

    return (
        <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center">
            <div className="text-center">
                <Loader2 className="w-12 h-12 animate-spin text-[#1B4D3E] mx-auto mb-4" />
                <p className="text-lg text-slate-600">Signing you in...</p>
            </div>
        </div>
    );
}
